import React from "react";
import Layout from "./Layout";
import { Parallax } from "react-parallax";
import { FaEnvelope, FaMobile } from "react-icons/fa";
import { Experience } from "./experience";

export default class Resume extends React.Component {
  render() {
    return (
      <Layout>
        <br />
        <div className="container-fluid resume">
          <div
            className="text-center"
            style={{
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <h1
              className="text-center"
              style={{
                fontWeight: "bold",
                fontSize: "4em",
              }}
            >
              Vishwaram <span style={{ color: "orange" }}>Maharaj</span>
            </h1>
            <Parallax
              bgImage={`${process.env.PUBLIC_URL}/assets/profile6.JPEG`}
              bgImageAlt="Vishwaram"
            >
              <div className="text-center" style={{ height: "400px" }}></div>
            </Parallax>
            <div className="row justify-content-center">
              {/* <div className="col-sm-3">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/profile4.png`}
                  alt="Vishwaram"
                  width={"100%"}
                  height={400}
                  style={{ border: "1px solid #fff", borderRadius: 5 }}
                />
              </div> */}
              {/* <div className="col-sm-3">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/profile2.png`}
                  alt="Vishwaram"
                  width={"100%"}
                  style={{ border: "1px solid #fff", borderRadius: 5 }}
                />
              </div> */}
              {/* <div className="col-sm-12">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/profile6.JPEG`}
                  alt="Vishwaram"
                  width={"100%"}
                  style={{ border: "1px solid #fff", borderRadius: 5 }}
                />
              </div> */}
              {/* <div className="col-sm-3">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/vbr.png`}
                  alt="Vishwaram"
                  width={"100%"}
                  style={{ border: "1px solid #fff", borderRadius: 5 }}
                />
              </div> */}
            </div>
            <div className="card bg-dark text-white">
              <div className="card-body">
                <div className="">
                  <a href="mailto:vishwaramm@gmail.com">
                    <FaEnvelope size={30} /> Email
                  </a>
                  <a href="tel:9144142079">
                    <FaMobile size={30} /> Phone
                  </a>
                </div>
              </div>
            </div>
          </div>
          <br />
          <br />
          <h5>Employment</h5>
          <hr />
          <div className="card bg-dark text-white">
            <div className="card-body">
              <div className={"employment-tile"} style={{}}>
                <div className="row">
                  <div className="col-sm-3 text-center">
                    <img
                      className="thumbnail"
                      src="https://design.gs.com/downloads/Goldman_Sachs_Blue_Box.png"
                      width={200}
                      height={200}
                      alt="Goldman Sachs"
                    />
                    <h3 className={"emp-title highlight"}>Vice President</h3>
                    <div className={"emp-duration"}>
                      December 2019 - Present
                    </div>
                  </div>
                  <div className="col-sm-9">
                    <div className="details">
                      <ul>
                        <li>
                          Work with traders in the securities division on
                          developing, maintaining, and releasing software having
                          to do with risk analysis, trading, and reporting.
                        </li>
                        <li>
                          Support legacy trading applications and intraday
                          trader/operations requests.
                        </li>
                        <li>
                          Working across teams on consuming APIs, making library
                          modifications, and performing releases.
                        </li>
                        <li>Ensure code is optimized and scalable.</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />
          <br />
          <div className="card bg-dark text-white">
            <div className="card-body">
              <div className="row">
                <div className="col-sm-3">
                  <div
                    className={"employment-tile"}
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <img
                      className="thumbnail"
                      src="https://www.ocf.berkeley.edu/~calche/wp-content/uploads/2016/02/TPR-Logo-1024x536.jpg"
                      width={200}
                      height={100}
                      alt="The Princeton Review"
                    />
                    <h3 className={"emp-title highlight"}>
                      Senior Software Engineer
                    </h3>
                    <div className={"emp-duration"}>
                      January 2015 - November 2019
                    </div>
                  </div>
                </div>
                <div className="col-sm-9">
                  <div className="details">
                    <ul>
                      <li>Manage multiple projects from concept to release.</li>
                      <li>
                        Work with product managers on specifications and release
                        timelines.
                      </li>
                      <li>
                        Ensure development team is using design patterns and
                        best practices throughout our codebase.
                      </li>
                      <li>Ensure code is optimized and scalable.</li>
                      <li>
                        Implemented learning algorithm that learns from student
                        responses to practice exams and serves the content in a
                        personalized way tailored to that student.
                      </li>
                      <li>
                        Implemented practice exam user interface for students to
                        take timed exams, highlight passages and questions, and
                        more features.
                      </li>
                      <li>
                        Implemented messaging user interface for counselors and
                        students to communicate privately.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />
          <br />
          <div className="card bg-dark text-white">
            <div className="card-body">
              <div className="row">
                <div className="col-sm-3">
                  <div
                    className={"employment-tile"}
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <img
                      className="thumbnail"
                      src="data:image/png;base64,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"
                      width={200}
                      height={150}
                      alt="Insight Catastrophe Group"
                    />
                    <h3 className={"emp-title highlight"}>Software Engineer</h3>
                    <div className={"emp-duration"}>
                      March 2014 - December 2014
                    </div>
                  </div>
                </div>
                <div className="col-sm-9">
                  <div className="details">
                    <ul>
                      <li>
                        Designed, documented, and built cloud-based risk
                        management processing service from scratch to that
                        determines whether to ensure an individual or entity.
                      </li>
                      <li>
                        Wrote new Infrastructure libraries for custom
                        authentication, common functionality, business
                        functionality, API adapters, etc.
                      </li>
                      <li>
                        Designed, documented, and built MVC 4 web application
                        for Catastrophe Modelers and clients to drastically
                        reduce the time it takes to setup modeling and scoring
                        parameters.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />
          <br />
          <div className="card bg-dark text-white">
            <div className="card-body">
              <div className="row">
                <div className="col-sm-3">
                  <div
                    className={"employment-tile"}
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <img
                      className="thumbnail"
                      src="https://healthitdirectory.com/wp-content/uploads/logos/free/Srssoft.jpg"
                      width={200}
                      height={150}
                      alt="SRS Soft"
                    />
                    <h3 className={"emp-title highlight"}>Software Engineer</h3>
                    <div className={"emp-duration"}>
                      April 2011 - March 2014
                    </div>
                  </div>
                </div>
                <div className="col-sm-9">
                  <div className="details">
                    <ul>
                      <li>
                        Work in multiple specialized teams of 4-8 developers to
                        develop, manage, and maintain software.
                      </li>
                      <li>
                        Implemented web applications that stores patient data
                        like blood pressure, problem codes, procedures, etc.
                      </li>
                      <li>
                        Designed, built, and maintained flexible Service
                        Oriented Architectures, Software as a Service, and WEB
                        APIs.
                      </li>
                      <li>
                        Designed and built multi-threaded, performance-oriented
                        services on the cloud for rapid processing, routing,
                        querying, and storing of patient health information.
                      </li>
                      <li>
                        Designed and built services which generate valid
                        government standards for maximum interoperability
                        between healthcare vendors and health information
                        exchanges.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <br />
          <h5>Education</h5>
          <hr />
          <div className="card bg-dark text-white">
            <div className="card-body">
              <div className="row">
                <div className="col-sm-6">
                  <div
                    className={"employment-tile"}
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <img
                      className="thumbnail"
                      src="https://upload.wikimedia.org/wikipedia/commons/d/d4/Pace_University_Logo.svg"
                      width={200}
                      height={150}
                      alt="Pace University"
                    />
                    <h3 className={"emp-title highlight"}>
                      M.S. Software Development &amp; Engineering
                    </h3>
                    <div className={"emp-duration"}>2014</div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div
                    className={"employment-tile"}
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <img
                      className="thumbnail"
                      src="https://www.stjohns.edu/sites/default/files/alumni-feature-sju-brand_0.jpg"
                      width={200}
                      height={150}
                      alt="St. John's Univeristy"
                    />
                    <h3 className={"emp-title highlight"}>
                      B.S. Computer Science, Networking and Telecommunication
                    </h3>
                    <div className={"emp-duration"}>2010</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />
          <br />
          <h5>Languages &amp; Technologies</h5>
          <hr />
          <div className="card bg-dark text-white">
            <div className="card-body">
              <Experience />
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}
